/* index.js */

"use strict";
let EntityGrid = require("@gluenetworks/entity_grid_gl");
let EntityTreeGrid = require("@gluenetworks/entity_tree_grid_gl");

module.exports = {
    Grid: {
        EntityGrid: EntityGrid,
        EntityTreeGrid: EntityTreeGrid,
    },
};
